<template>
    <div class="app-content content devcontent " >
        <div class="content-overlay"></div>
        <div class="header-navbar-shadow"></div>
        <div class="content-wrapper">
            <div class="content-header row">
            </div>
            <div class="content-body">
                <div class="auth-wrapper auth-v2">
                    <div class="auth-inner row m-0">
                        <a class="brand-logo" href="javascript:void(0);">
                        </a>
                        <!-- <div class="d-none d-lg-flex col-lg-8 align-items-center p-2">
                            <div class="w-100 d-lg-flex align-items-center justify-content-center px-5"><img class="img-fluid" src="../../public/images/pages/Illustration 2.svg" alt="Login V2" /></div>
                        </div> -->
                        <!-- /Left Text-->
                        <!-- Login-->
                        <div class="card d-flex col-lg-12 align-items-center auth-bg px-0 pb-2 mt-0">
                            <div  class="card-header bg-white pt-1 w-100 px-1 border-bottom_eee"><h4  class="card-title">User Registration</h4></div>
                            <div class="col-12 col-sm-8 col-md-6 col-lg-4 px-xl-2 mx-auto">
                                <!-- <div class="m-auto text-center d-block">
                                <img alt="" class="card-title font-weight-bold mb-1" src="../../public/images/logo/IntelliBee-Logo.png"  height="50px"> 
                                </div> -->
                                
                                <form class="auth-login-form mt-sm-1 mt-0" style="padding-right: 6px;" @submit.prevent="handleSubmit">
                                    <div class="form-group">
                                        <label class="form-label" for="login-name">Name<span class="requiredField">*</span></label>
                                        <input class="form-control" id="login-name" type="text"  v-model="name" placeholder="John Doe" aria-describedby="login-name" autofocus="" tabindex="1" />
                                    </div>
                                    <div class="form-group">
                                        <label class="form-label" for="login-email">Staff/User ID<span class="requiredField">*</span></label>
                                        <input class="form-control" id="login-email" type="text"  v-model="email" placeholder="XYZ_123" aria-describedby="login-email" autofocus="" tabindex="1" />
                                    </div>
                                    <div class="form-group">
                                        <div class="d-flex justify-content-between">
                                           <label for="login-password">Password<span class="requiredField">*</span></label>
                                        </div>
                                        <div class="input-group input-group-merge form-password-toggle">
                                            <input class="form-control form-control-merge" id="login-password"  v-model="password" v-if="showPassword" type="text"  placeholder="············" aria-describedby="login-password" tabindex="2" v-bind:class="{'form-control':true, 'is-invalid' : !validPassword(password) && passwordBlured}"/>
                                            <input class="form-control form-control-merge" id="login-password" v-model="password" v-else  type="password"  placeholder="············" aria-describedby="login-password" tabindex="2" v-bind:class="{'form-control':true, 'is-invalid' : !validPassword(password) && passwordBlured}" v-on:blur="passwordBlured = true"/>
                                            <div class="input-group-append" @click="toggleShow"><span class="input-group-text cursor-pointer">
                                            <eye-icon v-if="showPassword" size="1.5x" class="custom-class"></eye-icon>
                                            <eye-off-icon v-if="!showPassword" size="1.5x" class="custom-class"></eye-off-icon>
                                            </span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <div class="d-flex justify-content-between">
                                           <label for="verify_password">Verify Password<span class="requiredField">*</span></label>
                                        </div>
                                        <div class="input-group input-group-merge form-password-toggle">
                                            <input class="form-control" v-model="verify_password" type="password" placeholder="Enter password again"/>
                                            <!-- <div class="input-group-append" @click="showVerfiyPassword"><span class="input-group-text cursor-pointer">
                                            <eye-icon v-if="showVerifyPassword" size="1.5x" class="custom-class"></eye-icon>
                                            <eye-off-icon v-if="!showVerifyPassword" size="1.5x" class="custom-class"></eye-off-icon>
                                            </span>
                                            </div> -->
                                            <div class="errorinputmsg text-left" v-if="verify_password && password !== verify_password">
                                                Password must match
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <label class="form-label" for="mobile_number">Mobile Number</label>
                                        <input class="form-control" id="mobile_number" type="number"  v-model="mobile_number" placeholder="9876543210" aria-describedby="mobile_number" autofocus="" tabindex="1" />
                                        <div class="errorinputmsg text-left" v-if="mobile_number && !validateInput('mobile_number', mobile_number)">
                                        Invalid Mobile Number
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <label class="form-label" for="roleName">Role <span class="requiredField">*</span></label>
                                        <treeselect id="roleName" :multiple="true" placeholder="-- SELECT --" v-model="selectedRole" :options="roles" />
                                    </div>

                                    <button type="submit" class="btn btn-primary btn-block" tabindex="4"  :disabled="!validateForm()">
                                        <vue-element-loading
                                          :active="isLoggingIn"
                                          spinner="bar-fade-scale"
                                          color="#5bbdeb"
                                        />Register
                                    </button>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import axios from 'axios'
import { EyeIcon } from 'vue-feather-icons'
import { EyeOffIcon } from 'vue-feather-icons'
import VueElementLoading from "vue-element-loading";
import { VueRecaptcha } from 'vue-recaptcha';
import common_methods from "../utils/common_methods";
import searchMasterNameList from "../utils/searchMasterNameList";
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'

export default ({
    name:'Register',
    mixins: [common_methods, searchMasterNameList],
    components: {
        EyeIcon,
        EyeOffIcon,
        VueRecaptcha,
        VueElementLoading,
        Treeselect,
    },
    data(){
        return {
            name: null,
            email: null,
            password: null,
            verify_password: null,
            mobile_number: null,
            dbclient:'1',
            valid : false, 
            submitted : false,
            passwordBlured:false,
            showPassword: false,
            showVerfiyPassword: false,
            btndis: false,
            captcha_res: '',
            isLoggingIn: false,
            roles: [],
            selectedRole: null,

        }
        
    },
    computed: {
        buttonLabel() {
            return (this.showPassword) ? "Hide" : "Show";
        }
    },
    mounted() {
    },
    created() {
        this.getAllRoles()
    },
    methods:{
        async getAllRoles(){
            try{
                let { data } = await this.searchNameMasterList('auth_roles','role_name',null,'role_id')
                this.roles = data;
            } catch(e) {
                this.displayError(e)
            }
        },
        toggleShow() {
            this.showPassword = !this.showPassword;
        },
        showVerifyPassword() {
            this.showVerfiyPassword = !this.showVerfiyPassword;
        },
        validPassword : function(pasword) {
           if(this.password && this.password.trim() === "") {
                return false
           }
           return true
        },
        validateInput(inputType, fieldValue) {
            if(inputType === 'mobile_number') {
                let pattern = /^[0-9]{10}$/;
                return pattern.test(fieldValue);
            }
            return false
        },
        validateForm() {
            let isValid = true
            if(!this.email || (this.email && !this.email.trim())) {
                isValid = false 
                console.log(isValid, 1)

            }
            if(!this.password || (this.password && !this.password.trim()) || !this.verify_password || (this.verify_password && !this.verify_password.trim()) || this.password !== this.verify_password ) {
                isValid = false
                 console.log(isValid, 2)
            }
            if(!this.name || (this.name && !this.name.trim())) {
                isValid = false
                 console.log(isValid, 3)
            }
            if(this.mobile_number && !this.validateInput("mobile_number", this.mobile_number)) {
                isValid = false
            }
            if(!this.selectedRole || (this.selectedRole && !this.selectedRole.length)) {
                return false
            }

            return isValid
        },
        resetform() {
            this.email = null
            this.name = null
            this.mobile_number = null
            this.password = null
            this.verify_password = null
            this.selectedRole = null
        },
        handleSubmit() {
            if(!this.validateForm()) {
                this.sweetAlertSnackbar('Form was invalidated', 'error')
                return
            }
            this.isLoggingIn = true
            let payload = {
                name: this.name,
                password: this.password,
                username: this.email,
                mobile_number: this.mobile_number,
                roles: this.selectedRole
            }
            let url = "/user/register"
            this.makeRequest("POST", url, payload)
                .then(result => {
                    this.isLoggingIn = false
                    if(result.data.status) {
                        this.resetform()
                        this.sweetAlertSnackbar(result.data.message, 'success', 'top')
                        this.$router.push({
                            name: "Login_old"
                        });
                    } else {
                        this.sweetAlertSnackbar(result.data.message, 'error', 'top')
                    }
                })
                .catch(e => {
                    this.isLoggingIn = false
                    this.displayError(e)
                })
        }
    }
})
</script>

<style scoped>
   .buttonCaptcha{
    display:none;
   }
   .vue-captcha{
    margin: 0px auto!important;
     border: 1px solid #ddd!important;
    border-radius: 3px;
   }

   .form-group .rc-anchor-content {
    height: 74px;
    width: 60%!important;
}
.auth-login-form .input-group-append .input-group-text.cursor-pointer{
    border-top-right-radius: 5px!important;
    border-bottom-right-radius: 5px!important;
}
    
.requiredField {
    margin-left: 2px;
    color: red
}
.registerpagetop_padding .auth-inner{
    padding-top: 80px!important;
}
</style>